import { render, staticRenderFns } from "./BookingFiles.vue?vue&type=template&id=3452c9e8&"
import script from "./BookingFiles.vue?vue&type=script&lang=js&"
export * from "./BookingFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports